import React, { useEffect, useContext } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // #added botones a los programas 2/10/26 TG
import { AppContext } from "./ContextVars";
import translations from './translations';
const Functional = () => {

    const { language } = useContext(AppContext);
    const t = (key) => translations.Functional[key]?.[language] || key;
    const navigate = useNavigate(); // #added 2/10/26 TG

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    //------------------------------------
    // JSX
    //------------------------------------
    return (
      <div>
        <main>
          <AnimatePresence mode="wait">
              <motion.div
                key="functional-view"
                initial={{ opacity: 0, x: -40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 40 }}
                transition={{ duration: 0.4 }}
              >
                {/* #Hero Section */}
                <section id="functional" className="section overlay tint-black-50 height-40vh">
                  <div className="section__content">
                    <h2 className="general-title title-small-mobile">{t('title')}</h2>
                    <h2 className="font-size-20 color-gray-3">
                      {t('subtitle')}
                    </h2>
                  </div>
                </section>

                {/* #About the Program */}
                {/* #mod mismo fondo que el detalle de un programa (foto + degradado a negro) 2/10/26 TG */}
                <section className="section noheight padding-bottom-100 overlay tint-black-50 plan-detail-section">
                  <div className="section__content margin-top-140" style={{ position: "relative", zIndex: 2 }}>
                    <div className="gdiv width-80 gap-10px">
                      <h2 className="general-title title-small-mobile text-align-left move-left text-shadow">
                        {t('aboutTitle')}
                      </h2>
                      <div className="general-description text-align-left move-left text-shadow margin-top-20">
                        <p dangerouslySetInnerHTML={{ __html: t('aboutDesc1') }} />
                        <p className="margin-top-20" dangerouslySetInnerHTML={{ __html: t('aboutDesc2') }} />
                        <p className="margin-top-20" dangerouslySetInnerHTML={{ __html: t('aboutDesc3') }} />
                      </div>
                    </div>

                    {/* #Intro Program */}
                    <div className="gdiv width-80 gap-10px margin-top-100">
                      <h2 className="general-title title-small-mobile text-align-left move-left text-shadow">
                        {t('introTitle')}
                      </h2>
                      <div className="general-description text-align-left move-left text-shadow margin-top-20">
                        <p dangerouslySetInnerHTML={{ __html: t('introDesc1') }} />
                        <p className="margin-top-20" dangerouslySetInnerHTML={{ __html: t('introDesc2') }} />
                      </div>
                      <button className="button-2 move-left margin-top-30" onClick={() => navigate("/program/28")}>{/* #added Intro = plan 28 2/10/26 TG */}
                        {t('getIntro')}
                      </button>
                    </div>

                    {/* #Xplosive Program */}
                    <div className="gdiv width-80 gap-10px margin-top-100">
                      <h2 className="general-title title-small-mobile text-align-left move-left text-shadow">
                        {t('xplosiveTitle')}
                      </h2>
                      <div className="general-description text-align-left move-left text-shadow margin-top-20">
                        <p dangerouslySetInnerHTML={{ __html: t('xplosiveDesc1') }} />
                        <p className="margin-top-20" dangerouslySetInnerHTML={{ __html: t('xplosiveDesc2') }} />
                      </div>
                      <button className="button-2 move-left margin-top-30" onClick={() => navigate("/program/41")}>{/* #added Xplosive = plan 41 2/10/26 TG */}
                        {t('getXplosive')}
                      </button>
                    </div>

                  </div>
                </section>

              </motion.div>
          </AnimatePresence>
        </main>
      </div>
    );
    
};

export default Functional;
